import { apiCall } from '../../services/apiUtil';

// Strip empty strings so optional fields don't fail server-side format validation
function stripEmpty(obj) {
  return Object.fromEntries(Object.entries(obj).filter(([, v]) => v !== ''));
}

export const managedPlayersApi = {
  getAll: () => apiCall('/user?managedBy=me'),

  create: (data) => apiCall('/user', {
    method: 'POST',
    body: JSON.stringify({ managedBy: true, ...stripEmpty(data) })
  }),

  update: (id, data) => apiCall(`/user/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(stripEmpty(data))
  }),

  delete: (id) => apiCall(`/user/${id}`, { method: 'DELETE' }),

  invite: (managedPlayerId, inviterName) => apiCall('/invitations/managed-player', {
    method: 'POST',
    body: JSON.stringify({ managedPlayerId, inviterName })
  })
};
